import Box from "@material-ui/core/Box";
import { makeStyles, Theme } from "@material-ui/core/styles";
import React, { useRef } from "react";
import SignaturePad from "react-signature-canvas";
import { CustomButton } from "../../Ui/CustomButton";
import { MyDialog } from "../../Ui/MyDialog";

const styles = makeStyles((theme: Theme) => ({
  signatureCanvas: {
    border: "1px solid rgba(249,250,251,0.5)",
    height: 200,
    width: "100%",
    maxWidth: 400,
  },
  block: {
    width: "100%",
    height: "auto",
  },
  button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column-reverse",
    },
    marginTop: theme.spacing(1),
    "& > button": {
      margin: theme.spacing(1),
    },
  },
  content: {
    textAlign: "center",
    padding: theme.spacing(2),
  },
}));

interface CustomDialogSignaturePropsInterface {
  open: boolean;
  handleClose(): void;
  handleSave(signatureData: string): void;
}

const CustomDialogSignature = (props: CustomDialogSignaturePropsInterface) => {
  const { open, handleClose, handleSave } = props;
  const classes = styles();
  const signatureRef = useRef<any>();

  const closeDialog = () => {
    handleClose();
  };

  const saveSignature = () => {
    if (signatureRef && signatureRef.current) {
      handleSave(signatureRef.current.toDataURL("image/png"));
    }
    handleClose();
  };

  return (
    <MyDialog open={open} onClose={() => {}} fullWidth maxWidth="xs">
      <SignaturePad
        ref={signatureRef}
        canvasProps={{ className: classes.signatureCanvas }}
        minDistance={1}
      />
      <Box className={classes.button}>
        <CustomButton
          type="button"
          variant="outline4"
          onClick={closeDialog}
          label="cancel"
          fullWidthMobile
        />
        <CustomButton
          type="button"
          variant="primary"
          onClick={saveSignature}
          label="save"
          fullWidthMobile
        />
      </Box>
    </MyDialog>
  );
};

export default CustomDialogSignature;
